import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 *  Update Member Password Form context will wrap all children components and be available as merged props.
 */
export const UpdateMemberPasswordFormContextInstance = createEmptyContext();
